export const MARGIN_KINDS = ['labor', 'material', 'equipment', 'fee'];
export const MARGIN_KIND_LABELS = {
    labor: 'Labor', material: 'Materials', equipment: 'Equipment', fee: 'Fees',
};
/**
 * Five line kinds into four margin kinds. Subs count as labor (somebody's
 * hours, somebody else's invoice); deployment is the "Fees" link's kind.
 * `Record<QuoteLineKind, …>` makes the compiler refuse a new line kind nobody
 * mapped.
 */
export const MARGIN_KIND_OF = {
    labor: 'labor', sub: 'labor', item: 'material', equipment: 'equipment', deployment: 'fee',
};
/** Base: what they pay if they add nothing. Options: what may be added. All: the most they can spend. */
export const MARGIN_SCOPES = ['base', 'options', 'all'];
/**
 * The one percentage, from cents. Used by the server; exported so a test can
 * hold every caller to the same rounding.
 */
export function marginPctOf(soldCents, costCents) {
    if (soldCents <= 0)
        return null;
    return Math.round(((soldCents - costCents) * 1000) / soldCents) / 10;
}
/** The margin in whole points, from cents (see `MarginKindRow.marginPoints`). */
export function marginPointsOf(soldCents, costCents) {
    if (soldCents <= 0)
        return null;
    return Math.round(((soldCents - costCents) * 100) / soldCents);
}
//# sourceMappingURL=quote-margin.js.map